import { ChangeEvent, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { showNotification } from '@/utils/notificationUtils';
import { useUpdatePassword } from '../api/updatePassword';
import './UpdatePassword.scss';
import { Loader } from '@/components/Loader/Loader';
import { ReactComponent as Logo } from '@/assets/img/p-logo-r.svg';
import { ReactComponent as PasswordHideIcon } from '@/assets/img/password-hide-icon.svg';
import { ReactComponent as PasswordShowIcon } from '@/assets/img/password-show-icon.svg';
import storage from '@/utils/storage';
export const UpdatePassword = () => {
  const navigate = useNavigate();
  const search = useLocation().search;
  const token = new URLSearchParams(search).get('token');
  const updatePasswordMutation = useUpdatePassword();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.id === 'password') {
      setPassword(event.target.value);
    } else if (event.target.id === 'confirmpassword') {
      setConfirmPassword(event.target.value);
    }
  };
  const validate = () => {
    if (!password) {
      showNotification({
        type: 'info',
        title: 'Please enter password',
      });
      return false;
    } else if (password && password.length < 8) {
      showNotification({
        type: 'info',
        title: 'Password length should be at least 8 characters.',
      });
      return false;
    } else if (!confirmPassword || password != confirmPassword) {
      showNotification({
        type: 'info',
        title: 'Password not matched',
      });
      return false;
    }
    return true;
  };
  const extractUrlParams = (extend = false) => {
    const urlParams = new URLSearchParams(window.location.search);
    const params: any = {};
    urlParams.forEach((value, key) => {
      params[key] = value;
    });
    if (extend) {
      params.app_url = window.location.href;
      params.referrer_url = document.referrer;
    }
    return params;
  };
  const onResetPassword = async () => {
    if (validate()) {
      const urlParams = extractUrlParams();
      urlParams.promoCode && storage.setKey(`promoCode`, urlParams.promoCode);
      await updatePasswordMutation.mutateAsync({
        password,
        confirmPassword,
        token,
      });
      navigate('/');
    }
  };
  return (
    <section className="petsked-container-bg reset-password">
      <div className="logo-section">
        <Logo />
        <p className="petsked-desc">Reset Password </p>
      </div>
      <div className={`details`}>
        <div className="calender-row-center">
          <div className="petsked-form">
            <div className="form-field">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                className="cust-input-mobile is-reset-password "
                onChange={handleChange}
                placeholder="Enter new password"
              />
              {showPassword ? (
                <PasswordHideIcon onClick={() => setShowPassword(!showPassword)} />
              ) : (
                <PasswordShowIcon onClick={() => setShowPassword(!showPassword)} />
              )}
            </div>
            <div className="form-field">
              <input
                id="confirmpassword"
                type={showConfirmPassword ? 'text' : 'password'}
                value={confirmPassword}
                className="cust-input-mobile is-reset-password "
                onChange={handleChange}
                placeholder="Confirm password"
              />
              {showConfirmPassword ? (
                <PasswordHideIcon onClick={() => setShowConfirmPassword(!showConfirmPassword)} />
              ) : (
                <PasswordShowIcon onClick={() => setShowConfirmPassword(!showConfirmPassword)} />
              )}
            </div>
            <div className="action">
              <button
                className="petsked-button button-dark set-width-100"
                onClick={onResetPassword}
                disabled={updatePasswordMutation.isLoading}
              >
                {updatePasswordMutation.isLoading ? <Loader /> : <span>Update</span>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
